import { render, staticRenderFns } from "./BindOther.vue?vue&type=template&id=6168022f&scoped=true&"
import script from "./BindOther.vue?vue&type=script&lang=js&"
export * from "./BindOther.vue?vue&type=script&lang=js&"
import style0 from "./BindOther.vue?vue&type=style&index=0&id=6168022f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6168022f",
  null
  
)

export default component.exports